import { type FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { type ShareProvider } from '../StreamDashboard.types';

/*
    row: a strip of 4 tiles (54px tall between sm and md, to match the bookmark button). rail: fixed 50px squares
    from lg up.
    The fa-no-block-* classes keep ad blockers from hiding the brand icons.
*/

const PROVIDERS: { provider: ShareProvider; iconClass: string | null; label: string; color: string }[] = [
    { provider: 'twitter', iconClass: 'fab fa-no-block-tw', label: 'Twitter', color: 'bg-blue-twitter' },
    { provider: 'facebook', iconClass: 'fab fa-no-block-fb-official', label: 'Facebook', color: 'bg-blue-facebook' },
    { provider: 'linkedin', iconClass: 'fab fa-no-block-li', label: 'LinkedIn', color: 'bg-blue-linkedin' },
    { provider: 'email', iconClass: null, label: 'Email', color: 'bg-grey-not-so-light' },
];

type Props = {
    onShare: (provider: ShareProvider) => void;
    variant: 'row' | 'rail';
    className?: string;
};

export const ShareStreamSidebar: FC<Props> = ({ onShare, variant, className }) => (
    <div className={twMerge(variant === 'rail' ? 'fixed start-0 top-[110px] z-10 w-12.5' : 'flex w-full', className)}>
        {PROVIDERS.map(({ provider, iconClass, label, color }) => (
            <button
                key={provider}
                type="button"
                aria-label={label}
                onClick={() => onShare(provider)}
                className={twMerge(
                    'flex items-center justify-center text-2xl text-white',
                    variant === 'rail'
                        ? 'h-12.5 w-12.5'
                        : 'h-12.5 w-1/4 first:rounded-s-2 last:rounded-e-2 sm:h-[54px] md:h-12.5',
                    color,
                )}
            >
                {iconClass ? <i className={iconClass} /> : <FontAwesomeIcon icon={faEnvelope} />}
            </button>
        ))}
    </div>
);
